import { Popover } from 'react-tiny-popover';
import MoreIcon from '../../../../../assets/icons/more.svg?react';
import { useState } from 'react';
import { IoTrash } from 'react-icons/io5';
import { TbPencil } from 'react-icons/tb';
import { Menu, Item } from './style';

/* `onEdit` is optional and the entry only appears with it. On the classic page the way into a
   period's own fields — its quarter, its year, its filing date — is clicking the Year or Period cell
   of the row; the redesigned strip has no such cell, its head folds the period away instead, so the
   only way in has to be this menu. */
export default function RowAction({ onDelete, onEdit }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = e => {
    e?.preventDefault();
    e?.stopPropagation();

    setIsOpen(prev => !prev);
  };

  const handleEdit = e => {
    e?.preventDefault();
    e?.stopPropagation();
    toggle();
    onEdit();
  };

  const handleDelete = e => {
    e?.preventDefault();
    e?.stopPropagation();
    toggle();
    onDelete();
  };

  return (
    <Popover
      padding={10}
      isOpen={isOpen}
      onClickOutside={toggle}
      positions={['bottom']}
      transitionDuration={300}
      content={
        <Menu>
          {onEdit && (
            <Item onClick={handleEdit}>
              <TbPencil />
              Edit period
            </Item>
          )}
          <Item onClick={handleDelete} className="danger">
            <IoTrash />
            Delete
          </Item>
        </Menu>
      }
    >
      <button onClick={toggle} data-testid="RowAction">
        <MoreIcon />
      </button>
    </Popover>
  );
}
